import { render, staticRenderFns } from "./SMSBulkTaskManagement.vue?vue&type=template&id=0bd8073f&scoped=true"
import script from "./SMSBulkTaskManagement.vue?vue&type=script&lang=js"
export * from "./SMSBulkTaskManagement.vue?vue&type=script&lang=js"
import style0 from "./SMSBulkTaskManagement.vue?vue&type=style&index=0&id=0bd8073f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd8073f",
  null
  
)

export default component.exports